// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/webstrap/responsive-embed/responsive-embed.scss
 ** module id = 193
 ** module chunks = 0 1
 **/